import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import ServiceAuthSSO from '@/services/ServiceAuthSSO';
import { authStorage } from '@/lib/authStorage';

// Gate de AUTENTICAÇÃO (sem checar permissão). Sem token → manda pro login
// (SSO ou on-premise). Usado como layout route (envolve LayoutMain); a checagem
// de PERFIL fica no RequirePermission, rota a rota.
export function RequireAuth({ children }: Readonly<{ children?: React.ReactNode }>) {
  const token = authStorage.getItem('access_Token');
  if (!token) return <Navigate to={ServiceAuthSSO.isSSO() ? '/login/sso' : '/login'} replace />;
  return children ? <>{children}</> : <Outlet />;
}
